import { Box, VStack } from "@chakra-ui/react";
import useSupportTickets from "hooks/useSupportTickets";
import { FC } from "react";

import SupportTicketsList from "./SupportTicketsList";
import useCustomerUnreadTicketIds from "hooks/useCustomerUnreadTickets";

// This component would be particularly messy to decompose the buttons out of, unfortunately.
// It's not that gross of a file, so I'm going to leave it as-is for now.
const SupportTickets: FC = () => {
    const { data: tickets, isError } = useSupportTickets();
    const { data: unread } = useCustomerUnreadTicketIds();

    return isError || !tickets ? (
        <Box fontSize={24} color="error" fontWeight="semibold">
            Failed to load tickets
        </Box>
    ) : (
        <VStack align="start" w="100%" spacing={6}>
            {tickets.length > 0 ? (
                <SupportTicketsList
                    tickets={tickets}
                    unreadIds={unread?.ticketIds}
                />
            ) : (
                <Box>No messages</Box>
            )}
        </VStack>
    );
};

export default SupportTickets;
